import React, { useMemo } from "react";
import AccordionMenu from "@_components/accordion-menu";
import Sidebar from "components/sidebar";
import Image from "components/image";
import Icon from "@root/_components/Icon/icon";
import mapNestedObjects from "@root/helpers/mapNestedObject";
import lockBodyScroll from "@root/helpers/lockBodyScroll";

const MobileHeaderData = ({ data, logo, openedSidebar, setSidebar }) => {
    if (!data) return null;
    
    lockBodyScroll(openedSidebar);

    const navigationLinks = useMemo(() => {
        const mappedData = data.map((item) => {
            const nestedKey = "imageLinkData";
            return mapNestedObjects(item, nestedKey, "subItems", (links, depth) => ({
                // eslint-disable-next-line id-length
                id: links._key,
                title: links.directLink?.title || links.title,
                image: links.sidebarImage || links.directLink?.sidebarImage,
                url: links?.url || links.directLink?.url || "",
                subItems: links.subItems || [],
                slug: links.directLink?.url?.split("/").pop() || "",
            }));
        });

        return mappedData;
    }, [data]);

    const handleSideBarChange = (e, link, pathItems) => {
        if (link.subItems.length === 0) {
            setSidebar(!openedSidebar);
        }
    };
    
    return (
        <Sidebar openedSidebar={openedSidebar} setSidebar={setSidebar}>
            <div className="header_sidebar">
                <div className="header_sidebar-controls">
                    <button 
                        type="button"
                        onClick={() => setSidebar(!openedSidebar)}
                        aria-label="hamburger-menu"
                        className="header__sidebar-hamburger-btn"
                    >
                        <Icon icon="x" color="#00334e" size={32} />
                    </button>
                    <Image image={logo} to="/" width={125} className="header__sidebar-logo" />
                </div>
                <div className="header__sidebar-accordion-menu">
                    <AccordionMenu items={navigationLinks} onChange={handleSideBarChange} allowUrlClick />
                </div>
            </div>
        </Sidebar>
    );
};

export default MobileHeaderData;
